import React, { memo } from 'react'

import { Toggle } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import { NOOP } from 'Utils/stableDefaults'

function CollapsedSmartLowPolyRow() {
  const t = useTranslation()
  const isSmartLowPoly = useThreeDStudioStore(state => state.modelSettings.isSmartLowPoly)

  return (
    <Toggle
      id="collapsed-model-settings-smart-low-poly"
      label={t('leftSide.smartLowPoly.collapsedLabel')}
      className="collapsed-model-settings__toggle"
      isChecked={isSmartLowPoly}
      onChange={NOOP}
    />
  )
}

export default memo(CollapsedSmartLowPolyRow)
